import { GEOAPIFY_PLACE_DETAILS_URL } from "../constants";

import type { GeoJSONGeometry } from "./types";

interface PlaceDetailsFeature {
  geometry: GeoJSONGeometry;
  properties: { feature_type: string };
}

/**
 * Fetches the actual geometry (eg. an administrative boundary polygon or a
 * street line) of a Geoapify place from the Place Details API, given the
 * `place_id` returned by the autocomplete api. Returns undefined if the place
 * has no detailed geometry.
 */
const fetchPlaceDetailsGeometry = async (
  placeId: string,
  apiKey: string,
  signal?: AbortSignal,
): Promise<GeoJSONGeometry | undefined> => {
  const searchParams = new URLSearchParams({ apiKey, id: placeId });
  const response = await fetch(
    `${GEOAPIFY_PLACE_DETAILS_URL}?${searchParams.toString()}`,
    { signal },
  );
  const data = await response.json();
  if (data.error || data.message) {
    throw new Error(data.error || data.message);
  }
  const details = ((data.features || []) as PlaceDetailsFeature[]).find(
    (feature) => {
      return feature.properties?.feature_type === "details";
    },
  );
  return details?.geometry;
};

export default fetchPlaceDetailsGeometry;
